import { useTranslator } from 'components/shared/hooks';
import React, { Fragment } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { NotFoundView } from 'views/Errors/NotFound.view';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';

import { ROUTE_SETTINGS, ROUTE_SETTINGS_SYSTEM } from 'config/routes';
import { relativePath } from 'utils/navigation/relativePath';
import { SystemView } from 'views/Panel/Settings/System/System.view';

export const SettingsView = () => {
  const trans = useTranslator();

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.SETTINGS.CONFIG')} static />

      <Routes>
        <Route
          path={relativePath(ROUTE_SETTINGS, ROUTE_SETTINGS)}
          element={<Navigate to={ROUTE_SETTINGS_SYSTEM} replace />}
        />
        <Route path={relativePath(ROUTE_SETTINGS_SYSTEM, ROUTE_SETTINGS)} element={<SystemView />} />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
